export default {"src":"/_next/static/media/wave-desktop.00078e3f.svg","height":80,"width":1280,"blurWidth":0,"blurHeight":0};